// Languages
export const languages = [
	{ value: 'en', label: 'English' },
	{ value: 'no', label: 'Norsk' },
];

// File MIME Types
export const fileTypes = {
	document: ['application/pdf', 'application/msword', 'application/vnd.ms-excel'],
	video: ['video/mp4'],
	image: ['image/png', 'image/jpg', 'image/jpeg'],
};

// User Excel Schema
export const schema = {
	EMAIL: {
		prop: 'email',
		type: String,
		required: true,
	},
	PASSWORD: {
		prop: 'password',
		type: String,
		required: true,
		parse(value) {
			const passwordString = String(value);
			return passwordString;
		},
	},
	LANGUAGE: {
		prop: 'language',
		type: String,
		required: true,
	},
	'FIRST NAME': {
		prop: 'firstName',
		type: String,
		required: true,
	},
	'LAST NAME': {
		prop: 'lastName',
		type: String,
		required: true,
	},
	GENDER: {
		prop: 'gender',
		type: String,
		required: true,
	},
	ROLES: {
		prop: 'roles',
		type: String,
		required: true,
	},
};

// User Excel Schema
export const rundownSchema = {
	NAME: {
		prop: 'name',
		type: String,
		required: true,
	},
	DESCRIPTION: {
		prop: 'description',
		type: String,
		required: true,
	},
	DISPLAY_URL: {
		prop: 'display_url',
		type: String,
		required: true,
	},
	PUBLISHED: {
		prop: 'is_published',
		type: Boolean,
		required: true,
	},
	ARCHIVED: {
		prop: 'is_archived',
		type: Boolean,
		required: true,
	},
};

// template Excel Schema
export const templateSchema = {
	NAME: {
		prop: 'name',
		type: String,
		required: true,
	},
	CONTENT: {
		prop: 'content',
		type: String,
		required: true,
	},
	DESCRIPTION: {
		prop: 'description',
		type: String,
		required: true,
	},
	TYPE: {
		prop: 'type',
		type: String,
		required: true,
	},
	STATUS: {
		prop: 'status',
		type: String,
		required: true,
	},
};

// Rundown Item Excel Schema
export const rundownItemSchema = {
	NAME: {
		prop: 'name',
		type: String,
		required: true,
	},
	TYPE: {
		prop: 'type',
		type: String,
		required: true,
	},
	CONTENT: {
		prop: 'content',
		type: String,
		required: true,
	},
	LAYER_INDEX: {
		prop: 'layer_index',
		type: String,
		required: true,
	},
	STATUS: {
		prop: 'status',
		type: String,
		required: true,
	},
	IS_SHY: {
		prop: 'is_shy',
		type: Boolean,
		required: true,
	},
	is_play_live: {
		prop: 'is_play_live',
		type: Boolean,
		required: true,
	},
	is_play_preview: {
		prop: 'is_play_preview',
		type: Boolean,
		required: true,
	},
};

export const TOKEN_KEY = 'access_token';

// Rundown Item Types
export const itemTypes = [
	{ key: 'all', label: 'All' },
	{ key: 'lower_third', label: 'Lower Third' },
	// add seperate image and video
	{ key: 'image', label: 'Media - Still Image' },
	{ key: 'video', label: 'Media - Video' },

	{ key: 'custom_page', label: 'Browser Source' },
	{ key: 'timer', label: 'Timer' },
	{ key: 'ticker', label: 'Ticker' },
	{ key: 'zoom_meeting', label: 'Zoom Meeting' },
	{ key: 'video_input', label: 'Video Input' },
	{ key: 'lottie', label: 'Lottie' },
	{ key: 'composition', label: 'Composition' },
];

// Macro Item Actions
export const macroItemActions = [
	{ key: 'play', label: 'Play' },
	{ key: 'force_play', label: 'Force Play' },
	{ key: 'stop', label: 'Stop' },
	{ key: 'hide', label: 'Hide' },
	{ key: 'show', label: 'Show' },
];

// Macro Item Actions
export const macroItemActionsCustom = [
	{ key: 'play_next', label: 'Play Next' },
	{ key: 'play_previous', label: 'Play Previous' },
	{ key: 'stop_all', label: 'Stop All' },
	{ key: 'clear_output', label: 'Clear Output' },
];


export const lowerThirdDummyData = [
	{
		key: 1, h1: 'H1 HEADING TEXT GOES HERE', h2: 'H2 FOR SUB HEADING', h3: 'H3 GOES HERE', h4: 'H4 DESCRIPTION TEXT HERE',
	},
];
export const ColorDummyData =	{
	colorText1: '#FFFFFF',
	colorText2: '#333333',
	colorText3: '#FFFFFF',
	colorText4: '#333333',
	fillColor1: '#262626',
	fillColor2: '#FEA100',
	fillColor3: '#FF0000',
	fillColor4: '#CECECE',
};

export const customPageDummyData = [
	{
		key: 1, url: 'https://docs.google.com/presentation/d/e/2PACX-1vRBolPC_CbOFHcpPLEFvKBtsRuVpMRduuZyKdnGeZlIZpcgC3wcWYXI4x7CoifbWJwBKPThjEyoOrBp/embed?start=true&loop=false&delayms=3000',
	},
];

export const timerDummyData = [
	{
		message: 'EVENT WILL START AT',
		duration: '00:05:00',
		color: '#FFFFFF',
		bgColor: '#0053FF',
	},
];
export const tickerDummyData = [
	{
		tickerData: ['Lorem ipsum dolor sit amet consectetur adipiscing elit',
			'Vestibulum eget dolor sit amet eros ultrices sodales',
			'Nunc et risus non dui ullamcorper luctus quis quis arcu',
			'Curabitur tempor leo at molestie sodales',
			'Aliquam quis odio at ligula ultrices mollis in a lectus',
			'Morbi feugiat nibh non nisi eleifen nec imperdiet orci tempus',
			'Fusce in arcu ut tortor vulputate malesuada',
		],
		speed: 25,
		color: '#FFFFFF',
		bgColor: '#0053FF',
	},
];
// Position Options
export const positionOptions = [
	// { key: 'bottom-left', label: 'Bottom Left' },
	// { key: 'bottom-right', label: 'Bottom Right' },
	// { key: 'bottom-center', label: 'Bottom Center' },
	// { key: 'top-left', label: 'Top Left' },
	// { key: 'top-right', label: 'Top Right' },
	// { key: 'top-center', label: 'Top Center' },
	// { key: 'center', label: 'Center' },
	{ key: 'default', label: 'Default' },
	{ key: 'custom', label: 'Custom' },
];
export const blendModeOptions = [
	{ key: 'normal', label: 'Normal' },
	{ key: 'multiply', label: 'Multiply' },
	{ key: 'screen', label: 'Screen' },
	{ key: 'overlay', label: 'Overlay' },
	{ key: 'darken', label: 'Darken' },
	{ key: 'lighten', label: 'Lighten' },
	{ key: 'color-dodge;', label: 'Color-dodge' },
	{ key: 'color-burn', label: 'Color-burn' },
	{ key: 'hard-light', label: 'Hard-light' },
	{ key: 'soft-light', label: 'Soft-light' },
	{ key: 'difference', label: 'Difference' },
	{ key: 'exclusion', label: 'Exclusion' },
	{ key: 'hue', label: 'Hue' },
	{ key: 'saturation', label: 'Saturation' },
	{ key: 'color', label: 'Color' },
	{ key: 'luminosity', label: 'Luminosity' },


];
// Position Options
export const positionOptionsLT = [
	// { key: 'bottom-left', label: 'Bottom Left' },
	// { key: 'bottom-right', label: 'Bottom Right' },
	// { key: 'bottom-center', label: 'Bottom Center' },
	// { key: 'top-left', label: 'Top Left' },
	// { key: 'top-right', label: 'Top Right' },
	// { key: 'top-center', label: 'Top Center' },
	// { key: 'center', label: 'Center' },
	{ key: 'default', label: 'Default' },
	{ key: 'fullSize', label: 'Full Size' },
	{ key: 'halfSize', label: 'Half Size' },
	{ key: 'oneThirdSize', label: 'One Third' },
	{ key: 'custom', label: 'Custom' },
];
// zoom Role
export const zoomRoleOptions = [
	{ key: '0', label: 'Attendes' },
	{ key: '1', label: 'Host' },
	{ key: '5', label: 'Assistance' },
];

// font Style options
export const fontOptions = [
	{ key: '0', label: 'Abril Fatface' },
	{ key: '1', label: 'Aldrich' },
	{ key: '2', label: 'Arvo' },
	{ key: '3', label: 'Barlow Semi Condensed' },
	{ key: '4', label: 'Chakra Petch' },
	{ key: '5', label: 'Dosis' },
	{ key: '6', label: 'Frank Ruhl Libre' },
	{ key: '7', label: 'IBM Plex Sans' },
	{ key: '8', label: 'Inria Serif' },
	{ key: '9', label: 'Kaushan Script' },
	{ key: '10', label: 'Lato' },
	{ key: '11', label: 'Montserrat' },
	{ key: '12', label: 'Nova Flat' },
	{ key: '13', label: 'Nova Round' },
	{ key: '14', label: 'Open Sans' },
	{ key: '15', label: 'Playfair Display' },
	{ key: '16', label: 'Poppins' },
	{ key: '17', label: 'Quicksand' },
	{ key: '18', label: 'Roboto Slab' },
	{ key: '19', label: 'Roboto Condensed' },
	{ key: '20', label: 'Rubik' },
	{ key: '21', label: 'Titillium Web' },
	{ key: '22', label: 'Ubuntu' },


];

export const lottieSpeedOptions = [
	{ key: '0.25', label: '0.25' },
	{ key: '0.50', label: '0.50' },
	{ key: '0.75', label: '0.75' },
	{ key: '1', label: 'Normal' },
	{ key: '1.50', label: '1.50' },
	{ key: '2.0', label: '2.0' },
];
export const timerOptions = [
	{ key: 1, label: 'Clock' },
	{ key: 2, label: 'Count Down To Fixed Time' },
	{ key: 3, label: 'Count Down From Time' },
	{ key: 4, label: 'Count Up From Zero' },
	{ key: 5, label: 'Count Up From Fixed Time' },
	{ key: 6, label: 'Stopwatch' },
];
export const lottieScaleOptions = [
	{ key: 'default', label: 'Default' },
	{ key: 'small', label: 'Small' },
	{ key: 'large', label: 'Large' },

];
export const delayList = [
	{ name: 'No Delay', id: '0' },
	{ name: '-5', id: -5 },
	{ name: '-4', id: -4 },
	{ name: '-3', id: -3 },
	{ name: '-2', id: -2 },
	{ name: '-1', id: -1 },
	{ name: '+5', id: 5 },
	{ name: '+4', id: 4 },
	{ name: '+3', id: 3 },
	{ name: '+2', id: 2 },
	{ name: '+1', id: 1 },
];

const versionApp = process.env.VUE_APP_VERSION.split(/[.]/);
export const appVersion = `${versionApp[0]}.${versionApp[1]}.${versionApp[2]} Build (${versionApp[2]})`;

export const defaultStyleMulstiTwo = `
@import url("https://fonts.googleapis.com/css?family=Open+Sans+Condensed:300");
html, body {
	font-family: "Open Sans Condensed", sans-serif;
}

.panelistwrapper {
	position: absolute;
	top: 0px;
	left: 0px; 
}
.panelistwrapper1 {
	left: -460px; 
	top: 100px;
}

.panelistwrapper2 {
	left: 460px;
	top: 100px;
}


h1{
	font-size: 36px;
	line-height: 18px;
	margin-top: 0.5em;
}

h2{
	font-size: 24px;
	line-height: 12px;
	margin-top: 0.5em;
}
.panelistinfo {
	position: absolute;
	height: 100px;
	background-color: #D5fff1;
	text-align: center;
	padding: 0px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: clip;
	width: 800px;
	border-top-right-radius:10px;
	border-top-left-radius:10px;
	border-bottom-right-radius:10px;
	border-bottom-left-radius:10px;
}
.panelistinfo1 {
	top: 920px;
	left: 100px;
}

.panelistinfo2 {
	top: 920px;
	left: 1020px;
}
`;

export const timerTemplate = [
	{// system timer
		id: 1,
		content: "{\"content\":\"\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Abril+Fatface&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Aldrich&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Arvo&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Barlow+Semi+Condensed&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Chakra+Petch&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Dosis:wght@500&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Frank+Ruhl+Libre&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Inria+Serif&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Kaushan+Script&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Lato&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@1,700&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Nova+Flat&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Nova+Round&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Open+Sans&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@1,500&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Poppins&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Quicksand:wght@500&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Roboto+Condensed&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Roboto+Slab&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Rubik&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Titillium+Web&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Ubuntu&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\n<div id=\\\"parentcontainer\\\">\\n  <div id=\\\"container\\\">\\n    <div id=\\\"countdown\\\">\\n      <p  id=\\\"msg\\\">CLOCK</p>\\n      <h1 id=\\\"time\\\">00:00</h1>\\n    </div>\\n  </div>\\n</div>\",\"style\":\"body { \\n\\tfont-family: \'Montserrat\',\\n\\tsans-serif;\\n\\tmargin: 0;\\n  \\tpadding: 0;\\n\\n}\\n\\nh1 { \\n\\tfont-size: 15vw;\\n\\tmargin: 20px;\\n\\tline-height: .5em;\\n\\tletter-spacing: 5px;\\n\\tpadding-bottom: 8vw;\\n}\\n\\np {\\n\\tfont-size: 5vw;\\n\\tpadding: 0px;\\n\\tline-height: 1vh;\\n}\\n\\n\\n#parentcontainer { \\n  display: flex;\\n  width: 100vw;\\n  height: 100vh;\\n  justify-content: center;\\n  align-items: center;\\n\\n}\\n\\n#container { \\n\\tmargin: 0;\\n\\tdisplay: inline-block;\\n\\tpadding: 5px;\\n\\tborder-radius: 2vw;\\n}\\t\\n\\n#countdown{\\n\\ttext-align: center;\\n}\\n\\n\\nh1 > span {\\n  display: inline-block; /* Enable widths */\\n  width: 1.5em;           /* Set width across all characters */\\n  text-align: center; \\n     /* Even out spacing */\\n}\",\"script\":\"var secondCounter;\\nvar timelimit;\\nvar intervalHandle;\\nvar playingStatus = \'__STATUS__\'\\nvar playingId = \'__PLAYINGID__\'\\nvar endpoint = \'__APIURL__\'\\nvar tickerfont = [\\n\\t[\\\"Abril Fatface\\\", \\\"\'Abril Fatface\', cursive\\\"],\\n\\t[\\\"Aldrich\\\", \\\"\'Aldrich\', sans-serif\\\"],\\n\\t[\\\"Arvo\\\", \\\"\'Arvo\', serif\\\"],\\n\\t[\\\"Barlow Semi Condensed\\\", \\\"\'Barlow Semi Condensed\', sans-serif\\\"],\\n\\t[\\\"Chakra Petch\\\", \\\"\'Chakra Petch\', sans-serif\\\"],\\n\\t[\\\"Dosis\\\", \\\"\'Dosis\', sans-serif\\\"],\\n\\t[\\\"Frank Ruhl Libre\\\", \\\"\'Frank Ruhl Libre\', serif\\\"],\\n\\t[\\\"IBM Plex Sans\\\", \\\"\'IBM Plex Sans\', sans-serif\\\"],\\n\\t[\\\"Inria Serif\\\", \\\"\'Inria Serif\', serif\\\"],\\n\\t[\\\"Kaushan Script\\\", \\\"\'Kaushan Script\', cursive\\\"],\\n\\t[\\\"Lato\\\", \\\"\'Lato\', sans-serif\\\"],\\n\\t[\\\"Montserrat\\\", \\\"\'Montserrat\', sans-serif\\\"],\\n\\t[\\\"Nova Flat\\\", \\\"\'Nova Flat\', cursive\\\"],\\n\\t[\\\"Nova Round\\\", \\\"\'Nova Round\', cursive\\\"],\\n\\t[\\\"Open Sans\\\", \\\"\'Open Sans\', sans-serif\\\"],\\n\\t[\\\"Playfair Display\\\", \\\"\'Playfair Display\', serif\\\"],\\n\\t[\\\"Poppins\\\", \\\"\'Poppins\', sans-serif\\\"],\\n\\t[\\\"Quicksand\\\", \\\"\'Quicksand\', sans-serif\\\"],\\n\\t[\\\"Roboto Slab\\\", \\\"\'Roboto Slab\', serif\\\"],\\n\\t[\\\"Roboto Condensed\\\", \\\"\'Roboto Condensed\', sans-serif\\\"],\\n\\t[\\\"Rubik\\\", \\\"\'Rubik\', sans-serif\\\"],\\n\\t[\\\"Titillium Web\\\", \\\"\'Titillium Web\', sans-serif\\\"],\\n\\t[\\\"Ubuntu\\\", \\\"\'Ubuntu\', sans-serif\\\"]\\n];\\n\\n\\nstartClock(\'\', 1000, \\\"__color__\\\",\\\"__backgroundColor__\\\",\\\"__fontidx__\\\"  );\\n \\n\\nfunction receiveMessage(event) {\\n  \\n \\n    const data = event && event.data ? event.data:{};\\n    if (data && data.action === 'togglePause') {\\n\\t\\tisPaused = data.isPaused; \\n    }\\n  if (data && data.action === 'updatePreview') { clearInterval(intervalHandle); \\n} if (data && data.action === 'changeTemplate') { document.location.href = document.location.href; \\n}   } \\n\\nfunction tick(){\\n\\n\\tvar timeDisplay = document.getElementById(\\\"time\\\");\\n\\tvar time = new Date(),\\n    hour = time.getHours(),\\n    min = time.getMinutes(),\\n    sec = time.getSeconds();\\n\\n\\tif (hour < 10) {\\n\\t\\thour = \\\"0\\\" + hour;\\n\\t}\\n\\tif (min < 10) {\\n\\t\\tmin = \\\"0\\\" + min;\\n\\t}\\n\\tif (sec < 10) {\\n\\t\\tsec = \\\"0\\\" + sec;\\n\\t}\\n\\n\\tvar message = \'\';\\n\\n\\tmessage = hour.toString() + \\\":\\\" + min.toString() + \\\":\\\" + sec \\n\\ttimeDisplay.innerHTML =  message.replace(/(\\\\d+)/g, \'<span>$1</span>\');\\n\\n}\\n\\nfunction startClock(msg,secs, fgcolor, bgcolor, fontindex=0){ //init >   msg, duration-in-seconds, foreground-color, background-color\\n\\n\\t$(\'body\').css(\\\"font-family\\\", tickerfont[fontindex][1]);\\n\\n\\n\\tif(msg != undefined && msg == \'\'){\\n\\t\\t document.getElementById(\\\"msg\\\").remove()\\n\\t\\t $(\'h1\').css(\\\"padding\\\", \'40px\');\\n\\t}else{\\n\\t\\t\\n\\t\\tdocument.getElementById(\\\"msg\\\").innerHTML = msg;\\n\\t\\t$(\'p\').css(\\\"font-size\\\", (msg.length) < 10 ? \'7vw\' : \'4vw\');\\n\\t\\t$(\'p\').css(\\\"line-height\\\", (msg.length) < 10 ? \'1vh\' : \'6vh\');\\n\\t}\\n\\n  document.getElementById(\\\"countdown\\\").style.color = fgcolor;\\n\\tdocument.getElementById(\\\"container\\\").style.backgroundColor  = bgcolor + __SHOWBG__;\\n\\n\\tsetInterval(tick, 1000);\\n\\n \\n\\n\\n window.addEventListener('message', receiveMessage);\\n }\\n\\n\\n\\n\\n\\n\",\"vcam_count\":\"\"}",
	},
	{// count down fixed time
		id: 2,
		// eslint-disable-next-line no-template-curly-in-string
		content: "{\"content\":\"<!DOCTYPE html>\\n<html lang=\\\"en\\\" >\\n<head>\\n  <meta charset=\\\"UTF-8\\\">\\n  <title>GRAFIAS - COUNTDOWN</title>\\n\\n  \\t<link rel=\\\"stylesheet\\\" href=\\\"./style.css\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Abril+Fatface&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Aldrich&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Arvo&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Barlow+Semi+Condensed&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Chakra+Petch&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Dosis:wght@500&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Frank+Ruhl+Libre&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Inria+Serif&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Kaushan+Script&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Lato&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@1,700&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Nova+Flat&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Nova+Round&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Open+Sans&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@1,500&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Poppins&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Quicksand:wght@500&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Roboto+Condensed&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Roboto+Slab&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Rubik&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Titillium+Web&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Ubuntu&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\n<body>\\n<!-- partial:index.partial.html -->\\n<!DOCTYPE html>\\n<html>\\n\\t<body>\\n\\t\\t<div id=\\\"parentcontainer\\\">\\n\\t\\t\\t<div id=\\\"container\\\">\\n\\t\\t\\t\\t<div id=\\\"countdown\\\">\\n\\t\\t\\t\\t\\t<p  id=\\\"msg\\\">COUNTDOWN</p>\\n\\t\\t\\t\\t\\t<h1 id=\\\"time\\\">0:00</h1>\\n\\t\\t\\t\\t</div>\\n\\t\\t\\t</div>\\n\\t\\t</div>\\n\\t</body>\\n<!-- partial -->\\n</body>\\n</html>\",\"style\":\"body { \\n\\tfont-family: 'Montserrat',\\n\\tsans-serif;\\n\\tmargin: 0;\\n  \\tpadding: 0;\\n\\n}\\n\\nh1 { \\n\\tfont-size: 15vw;\\n\\tmargin: 20px;\\n\\tline-height: .5em;\\n\\tletter-spacing: 5px;\\n\\tpadding-bottom: 8vw;\\n}\\n\\np {\\n\\tfont-size: 3vw;\\n\\tpadding-bottom: 0.5vw;\\n}\\n\\n\\n#parentcontainer { \\n  display: flex;\\n  width: 100vw;\\n  height: 100vh;\\n  justify-content: center;\\n  align-items: center;\\n\\n}\\n\\n#container { \\n\\tmargin: 0;\\n\\tdisplay: inline-block;\\n\\tpadding: 15px;\\n\\tborder-radius: 1vw;\\n}\\t\\n\\n#countdown{\\n\\ttext-align: center;\\n}\\n\\n\\nh1 > span {\\n  display: inline-block; /* Enable widths */\\n  width: 1.5em;           /* Set width across all characters */\\n  text-align: center; \\n     /* Even out spacing */\\n}\",\"script\":\"var secondsRemaining;\\nvar intervalHandle;\\nvar playingStatus = '__STATUS__'\\nvar playingId = '__PLAYINGID__'\\nvar endpoint = '__APIURL__'\\nvar completeItem = '__ONCOMPLETEITEM__'\\nvar tickerfont = [\\n\\t[\\\"Abril Fatface\\\", \\\"'Abril Fatface', cursive\\\"],\\n\\t[\\\"Aldrich\\\", \\\"'Aldrich', sans-serif\\\"],\\n\\t[\\\"Arvo\\\", \\\"'Arvo', serif\\\"],\\n\\t[\\\"Barlow Semi Condensed\\\", \\\"'Barlow Semi Condensed', sans-serif\\\"],\\n\\t[\\\"Chakra Petch\\\", \\\"'Chakra Petch', sans-serif\\\"],\\n\\t[\\\"Dosis\\\", \\\"'Dosis', sans-serif\\\"],\\n\\t[\\\"Frank Ruhl Libre\\\", \\\"'Frank Ruhl Libre', serif\\\"],\\n\\t[\\\"IBM Plex Sans\\\", \\\"'IBM Plex Sans', sans-serif\\\"],\\n\\t[\\\"Inria Serif\\\", \\\"'Inria Serif', serif\\\"],\\n\\t[\\\"Kaushan Script\\\", \\\"'Kaushan Script', cursive\\\"],\\n\\t[\\\"Lato\\\", \\\"'Lato', sans-serif\\\"],\\n\\t[\\\"Montserrat\\\", \\\"'Montserrat', sans-serif\\\"],\\n\\t[\\\"Nova Flat\\\", \\\"'Nova Flat', cursive\\\"],\\n\\t[\\\"Nova Round\\\", \\\"'Nova Round', cursive\\\"],\\n\\t[\\\"Open Sans\\\", \\\"'Open Sans', sans-serif\\\"],\\n\\t[\\\"Playfair Display\\\", \\\"'Playfair Display', serif\\\"],\\n\\t[\\\"Poppins\\\", \\\"'Poppins', sans-serif\\\"],\\n\\t[\\\"Quicksand\\\", \\\"'Quicksand', sans-serif\\\"],\\n\\t[\\\"Roboto Slab\\\", \\\"'Roboto Slab', serif\\\"],\\n\\t[\\\"Roboto Condensed\\\", \\\"'Roboto Condensed', sans-serif\\\"],\\n\\t[\\\"Rubik\\\", \\\"'Rubik', sans-serif\\\"],\\n\\t[\\\"Titillium Web\\\", \\\"'Titillium Web', sans-serif\\\"],\\n\\t[\\\"Ubuntu\\\", \\\"'Ubuntu', sans-serif\\\"]\\n];\\n\\nstartCountdown('__message__', '__time__', \\\"__color__\\\",\\\"__fontidx__\\\", \\\"__backgroundColor__\\\" ); //init >   msg, duration-in-seconds, foreground-color, background-color\\n \\n\\nfunction receiveMessage(event) {\\n  \\n \\n    const data = event && event.data ? event.data:{}; \\n    if (data && data.action === 'togglePause') {\\n\\t\\tisPaused = data.isPaused; \\n    }\\n  if (data && data.action === 'updatePreview') {  clearInterval(intervalHandle); \\n} \\n if (data && data.action === 'changeTemplate') { document.location.href = document.location.href; \\n}\\n }\\n\\nfunction tick() {\\n\\tvar timeDisplay = document.getElementById(\\\"time\\\");\\n\\tvar hour = Math.floor(secondsRemaining / 3600);\\n\\tvar min = Math.floor((secondsRemaining - (hour * 3600)) / 60);\\n\\tvar sec = secondsRemaining - (hour * 3600) - (min * 60);\\n\\n\\tif (hour < 10) {\\n\\t\\thour = \\\"0\\\" + hour;\\n\\t}\\n\\tif (min < 10) {\\n\\t\\tmin = \\\"0\\\" + min;\\n\\t}\\n\\tif (sec < 10) {\\n\\t\\tsec = \\\"0\\\" + sec;\\n\\t}\\n\\tvar message = '';\\n\\tif (hour > 0) { \\n\\t\\tmessage = hour.toString() + \\\":\\\" + min.toString() + \\\":\\\" + sec \\n\\t} else if (hour == 0 && min > 0) { \\n\\t\\tmessage = min.toString() + \\\":\\\" + sec; \\n\\t} else if (min == 0) { \\n\\t\\tmessage = sec; \\n\\t}\\n\\ttimeDisplay.innerHTML = message;\\n\\tif (secondsRemaining === 0){\\n\\t\\tcountdownDone();\\n\\t\\tclearInterval(intervalHandle);\\t\\n\\t}\\n\\tsecondsRemaining--;\\n}\\n\\nfunction rnd(min, max){\\n    const r = Math.random()*(max-min) + min\\n    return Math.floor(r)\\n}\\n\\nfunction startCountdown(msg,secs, fgcolor,fontidx=rnd(0,21), bgcolor){ \\n\\t$('body').css(\\\"font-family\\\", tickerfont[fontidx][1]);\\n\\tvar hms = secs;   // your input string\\n\\tvar a = hms.split(':'); // split it at the colons\\n    var date = new Date;\\n    var scnd = date.getSeconds();\\n    var minutes = date.getMinutes();\\n    var hour = date.getHours();\\n\\tlet seconds = (+a[0] - hour) * 60 * 60 + (+a[1] - minutes) * 60 + (+a[2] - scnd);\\n\\n\\tif (msg != undefined && msg == ''){\\n\\t\\t document.getElementById(\\\"msg\\\").remove()\\n\\t\\t  $('h1').css(\\\"padding\\\", '20px');\\n\\n\\t} else{\\n\\t\\t\\n\\t\\tdocument.getElementById(\\\"msg\\\").innerHTML = msg;\\n\\t\\t$('p').css(\\\"font-size\\\", (msg.length) < 14 ? '7vw' : '3vw');\\n\\t\\t$('p').css(\\\"line-height\\\", (msg.length) < 14 ? '1vh' : '6vh');\\n\\t}\\n  \\n\\tdocument.getElementById(\\\"countdown\\\").style.color = fgcolor;\\n\\tdocument.getElementById(\\\"container\\\").style.backgroundColor  = bgcolor + __SHOWBG__;\\n  \\t\\n  \\tif (seconds<=0) seconds = seconds+ 86399\\n\\tsecondsRemaining = seconds;\\n\\tintervalHandle = setInterval(tick, 1000);\\n\\n}\\n\\nasync function onCompleteItem() {\\n    await fetch(`${endpoint}/rundownItems/${completeItem}/playLive`, {\\n      method: 'GET',\\n        headers: {\\n          'Accept': 'application/json',\\n          'Content-Type': 'application/json'\\n      },\\n    })\\n    .then((response) => {\\n\\n    });\\n}\\n\\n\\nasync function countdownDone(){\\n\\tdocument.getElementById(\\\"container\\\").style.display = \\\"none\\\";\\n  if (completeItem) {\\n    \\tonCompleteItem()\\n    }\\nawait fetch(`${endpoint}/rundownItems/stopAll/${playingId}/${playingStatus}`, {\\n\\t\\t\\t\\tmethod: 'POST',\\n\\t\\t\\t\\theaders: {\\n\\t\\t\\t\\t\\t'Accept': 'application/json',\\n\\t\\t\\t\\t\\t'Content-Type': 'application/json'\\n\\t\\t\\t\\t},\\n\\t\\t\\t})\\n\\t\\t\\t.then((response) => {\\n\\t\\t\\t\\t\\n\\t\\t\\t});\\n} \\n\\n\\n window.addEventListener('message', receiveMessage);\\n\\n\\n\",\"vcam_count\":\"\"}",
	},
	{// count down normal
		id: 3,
		// eslint-disable-next-line no-template-curly-in-string
		content: "{\"content\":\"<!DOCTYPE html>\\n<html lang=\\\"en\\\" >\\n<head>\\n  <meta charset=\\\"UTF-8\\\">\\n  <title>GRAFIAS - COUNTDOWN</title>\\n\\n  \\t<link rel=\\\"stylesheet\\\" href=\\\"./style.css\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Abril+Fatface&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Aldrich&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Arvo&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Barlow+Semi+Condensed&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Chakra+Petch&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Dosis:wght@500&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Frank+Ruhl+Libre&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Inria+Serif&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Kaushan+Script&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Lato&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@1,700&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Nova+Flat&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Nova+Round&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Open+Sans&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@1,500&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Poppins&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Quicksand:wght@500&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Roboto+Condensed&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Roboto+Slab&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Rubik&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Titillium+Web&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Ubuntu&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\n<body>\\n<!-- partial:index.partial.html -->\\n<!DOCTYPE html>\\n<html>\\n\\t<body>\\n\\t\\t<div id=\\\"parentcontainer\\\">\\n\\t\\t\\t<div id=\\\"container\\\">\\n\\t\\t\\t\\t<div id=\\\"countdown\\\">\\n\\t\\t\\t\\t\\t<p  id=\\\"msg\\\">COUNTDOWN</p>\\n\\t\\t\\t\\t\\t<h1 id=\\\"time\\\">0:00</h1>\\n\\t\\t\\t\\t</div>\\n\\t\\t\\t</div>\\n\\t\\t</div>\\n\\t</body>\\n<!-- partial -->\\n</body>\\n</html>\",\"style\":\"body { \\n\\tfont-family: 'Montserrat',\\n\\tsans-serif;\\n\\tmargin: 0;\\n  \\tpadding: 0;\\n\\n}\\n\\nh1 { \\n\\tfont-size: 15vw;\\n\\tmargin: 20px;\\n\\tline-height: .5em;\\n\\tletter-spacing: 5px;\\n\\tpadding-bottom: 8vw;\\n}\\n\\np {\\n\\tfont-size: 3vw;\\n\\tpadding-bottom: 0.5vw;\\n}\\n\\n\\n#parentcontainer { \\n  display: flex;\\n  width: 100vw;\\n  height: 100vh;\\n  justify-content: center;\\n  align-items: center;\\n\\n}\\n\\n#container { \\n\\tmargin: 0;\\n\\tdisplay: inline-block;\\n\\tpadding: 15px;\\n\\tborder-radius: 1vw;\\n}\\t\\n\\n#countdown{\\n\\ttext-align: center;\\n}\\n\\n\\nh1 > span {\\n  display: inline-block; /* Enable widths */\\n  width: 1.5em;           /* Set width across all characters */\\n  text-align: center; \\n     /* Even out spacing */\\n}\",\"script\":\"var secondsRemaining;\\nvar intervalHandle;\\nvar playingStatus = '__STATUS__'\\nvar playingId = '__PLAYINGID__'\\nvar endpoint = '__APIURL__'\\nvar completeItem = '__ONCOMPLETEITEM__'\\nvar tickerfont = [\\n\\t[\\\"Abril Fatface\\\", \\\"'Abril Fatface', cursive\\\"],\\n\\t[\\\"Aldrich\\\", \\\"'Aldrich', sans-serif\\\"],\\n\\t[\\\"Arvo\\\", \\\"'Arvo', serif\\\"],\\n\\t[\\\"Barlow Semi Condensed\\\", \\\"'Barlow Semi Condensed', sans-serif\\\"],\\n\\t[\\\"Chakra Petch\\\", \\\"'Chakra Petch', sans-serif\\\"],\\n\\t[\\\"Dosis\\\", \\\"'Dosis', sans-serif\\\"],\\n\\t[\\\"Frank Ruhl Libre\\\", \\\"'Frank Ruhl Libre', serif\\\"],\\n\\t[\\\"IBM Plex Sans\\\", \\\"'IBM Plex Sans', sans-serif\\\"],\\n\\t[\\\"Inria Serif\\\", \\\"'Inria Serif', serif\\\"],\\n\\t[\\\"Kaushan Script\\\", \\\"'Kaushan Script', cursive\\\"],\\n\\t[\\\"Lato\\\", \\\"'Lato', sans-serif\\\"],\\n\\t[\\\"Montserrat\\\", \\\"'Montserrat', sans-serif\\\"],\\n\\t[\\\"Nova Flat\\\", \\\"'Nova Flat', cursive\\\"],\\n\\t[\\\"Nova Round\\\", \\\"'Nova Round', cursive\\\"],\\n\\t[\\\"Open Sans\\\", \\\"'Open Sans', sans-serif\\\"],\\n\\t[\\\"Playfair Display\\\", \\\"'Playfair Display', serif\\\"],\\n\\t[\\\"Poppins\\\", \\\"'Poppins', sans-serif\\\"],\\n\\t[\\\"Quicksand\\\", \\\"'Quicksand', sans-serif\\\"],\\n\\t[\\\"Roboto Slab\\\", \\\"'Roboto Slab', serif\\\"],\\n\\t[\\\"Roboto Condensed\\\", \\\"'Roboto Condensed', sans-serif\\\"],\\n\\t[\\\"Rubik\\\", \\\"'Rubik', sans-serif\\\"],\\n\\t[\\\"Titillium Web\\\", \\\"'Titillium Web', sans-serif\\\"],\\n\\t[\\\"Ubuntu\\\", \\\"'Ubuntu', sans-serif\\\"]\\n];\\n\\nstartCountdown('__message__', '__time__', \\\"__color__\\\",\\\"__fontidx__\\\", \\\"__backgroundColor__\\\" ); //init >   msg, duration-in-seconds, foreground-color, background-color\\n \\n\\nfunction receiveMessage(event) {\\n  \\n \\n    const data = event && event.data ? event.data:{}; \\n    if (data && data.action === 'togglePause') {\\n\\t\\tisPaused = data.isPaused; \\n    }\\n  if (data && data.action === 'updatePreview') {  clearInterval(intervalHandle); \\n} \\n if (data && data.action === 'changeTemplate') { document.location.href = document.location.href; \\n}\\n }\\n\\nfunction tick() {\\n\\tvar timeDisplay = document.getElementById(\\\"time\\\");\\n\\tvar hour = Math.floor(secondsRemaining / 3600);\\n\\tvar min = Math.floor((secondsRemaining - (hour * 3600)) / 60);\\n\\tvar sec = secondsRemaining - (hour * 3600) - (min * 60);\\n\\n\\tif (hour < 10) {\\n\\t\\thour = \\\"0\\\" + hour;\\n\\t}\\n\\tif (min < 10) {\\n\\t\\tmin = \\\"0\\\" + min;\\n\\t}\\n\\tif (sec < 10) {\\n\\t\\tsec = \\\"0\\\" + sec;\\n\\t}\\n\\tvar message = '';\\n\\tif (hour > 0) { \\n\\t\\tmessage = hour.toString() + \\\":\\\" + min.toString() + \\\":\\\" + sec \\n\\t} else if (hour == 0 && min > 0) { \\n\\t\\tmessage = min.toString() + \\\":\\\" + sec; \\n\\t} else if (min == 0) { \\n\\t\\tmessage = sec; \\n\\t}\\n\\ttimeDisplay.innerHTML = message;\\n\\tif (secondsRemaining === 0){\\n\\t\\tcountdownDone();\\n\\t\\tclearInterval(intervalHandle);\\t\\n\\t}\\n\\tsecondsRemaining--;\\n}\\n\\nfunction rnd(min, max){\\n    const r = Math.random()*(max-min) + min\\n    return Math.floor(r)\\n}\\n\\nfunction startCountdown(msg,secs, fgcolor,fontidx=rnd(0,21), bgcolor){ \\n\\t$('body').css(\\\"font-family\\\", tickerfont[fontidx][1]);\\n\\tvar hms = secs;   // your input string\\n\\tvar a = hms.split(':'); // split it at the colons\\n\\tconst seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);\\n\\n\\tif (msg != undefined && msg == ''){\\n\\t\\t document.getElementById(\\\"msg\\\").remove()\\n\\t\\t  $('h1').css(\\\"padding\\\", '20px');\\n\\n\\t} else{\\n\\t\\t\\n\\t\\tdocument.getElementById(\\\"msg\\\").innerHTML = msg;\\n\\t\\t$('p').css(\\\"font-size\\\", (msg.length) < 14 ? '7vw' : '3vw');\\n\\t\\t$('p').css(\\\"line-height\\\", (msg.length) < 14 ? '1vh' : '6vh');\\n\\t}\\n  \\n\\tdocument.getElementById(\\\"countdown\\\").style.color = fgcolor;\\n\\tdocument.getElementById(\\\"container\\\").style.backgroundColor  = bgcolor + __SHOWBG__;\\n\\tsecondsRemaining = seconds;\\n\\tintervalHandle = setInterval(tick, 1000);\\n\\n}\\n\\nasync function onCompleteItem() {\\n    await fetch(`${endpoint}/rundownItems/${completeItem}/playLive`, {\\n      method: 'GET',\\n        headers: {\\n          'Accept': 'application/json',\\n          'Content-Type': 'application/json'\\n      },\\n    })\\n    .then((response) => {\\n\\n    });\\n}\\n\\n\\nasync function countdownDone(){\\n\\tdocument.getElementById(\\\"container\\\").style.display = \\\"none\\\";\\n  if (completeItem) {\\n    \\tonCompleteItem()\\n    }\\nawait fetch(`${endpoint}/rundownItems/stopAll/${playingId}/${playingStatus}`, {\\n\\t\\t\\t\\tmethod: 'POST',\\n\\t\\t\\t\\theaders: {\\n\\t\\t\\t\\t\\t'Accept': 'application/json',\\n\\t\\t\\t\\t\\t'Content-Type': 'application/json'\\n\\t\\t\\t\\t},\\n\\t\\t\\t})\\n\\t\\t\\t.then((response) => {\\n\\t\\t\\t\\t\\n\\t\\t\\t});\\n} \\n\\n\\n window.addEventListener('message', receiveMessage);\\n\\n\\n\",\"vcam_count\":\"\"}",
	},
	{// count up start from zero
		id: 4,
		// eslint-disable-next-line no-template-curly-in-string
		content: "{\"content\":\"<link href=\\\"https://fonts.googleapis.com/css2?family=Abril+Fatface&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Aldrich&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Arvo&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Barlow+Semi+Condensed&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Chakra+Petch&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Dosis:wght@500&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Frank+Ruhl+Libre&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Inria+Serif&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Kaushan+Script&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Lato&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@1,700&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Nova+Flat&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Nova+Round&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Open+Sans&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@1,500&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Poppins&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Quicksand:wght@500&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Roboto+Condensed&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Roboto+Slab&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Rubik&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Titillium+Web&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Ubuntu&display=swap\\\" rel=\\\"stylesheet\\\">\\t\\n<div id=\\\"parentcontainer\\\">\\n  <div id=\\\"container\\\">\\n    <div id=\\\"countdown\\\">\\n      <p  id=\\\"msg\\\">COUNTUP</p>\\n      <h1 id=\\\"time\\\">00:00</h1>\\n    </div>\\n  </div>\\n</div>\",\"style\":\"body { \\n\\tfont-family: 'Montserrat',\\n\\tsans-serif;\\n\\tmargin: 0;\\n  \\tpadding: 0;\\n\\n}\\n\\nh1 { \\n\\tfont-size: 15vw;\\n\\tmargin: 20px;\\n\\tline-height: .5em;\\n\\tletter-spacing: 5px;\\n\\tpadding-bottom: 8vw;\\n}\\n\\np {\\n\\tfont-size: 3vw;\\n\\tpadding-bottom: 0.5vw;\\n}\\n\\n\\n#parentcontainer { \\n  display: flex;\\n  width: 100vw;\\n  height: 100vh;\\n  justify-content: center;\\n  align-items: center;\\n\\n}\\n\\n#container { \\n\\tmargin: 0;\\n\\tdisplay: inline-block;\\n\\tpadding: 15px;\\n\\tborder-radius: 2vw;\\n}\\t\\n\\n#countdown{\\n\\ttext-align: center;\\n}\\n\\n\\nh1 > span {\\n  display: inline-block; /* Enable widths */\\n  width: 1.5em;           /* Set width across all characters */\\n  text-align: center; \\n     /* Even out spacing */\\n}\",\"script\":\"var secondCounter;\\nvar timelimit;\\nvar intervalHandle;\\nvar playingStatus = '__STATUS__'\\nvar playingId = '__PLAYINGID__'\\nvar endpoint = '__APIURL__'\\n\\nvar tickerfont = [\\n\\t[\\\"Abril Fatface\\\", \\\"'Abril Fatface', cursive\\\"],\\n\\t[\\\"Aldrich\\\", \\\"'Aldrich', sans-serif\\\"],\\n\\t[\\\"Arvo\\\", \\\"'Arvo', serif\\\"],\\n\\t[\\\"Barlow Semi Condensed\\\", \\\"'Barlow Semi Condensed', sans-serif\\\"],\\n\\t[\\\"Chakra Petch\\\", \\\"'Chakra Petch', sans-serif\\\"],\\n\\t[\\\"Dosis\\\", \\\"'Dosis', sans-serif\\\"],\\n\\t[\\\"Frank Ruhl Libre\\\", \\\"'Frank Ruhl Libre', serif\\\"],\\n\\t[\\\"IBM Plex Sans\\\", \\\"'IBM Plex Sans', sans-serif\\\"],\\n\\t[\\\"Inria Serif\\\", \\\"'Inria Serif', serif\\\"],\\n\\t[\\\"Kaushan Script\\\", \\\"'Kaushan Script', cursive\\\"],\\n\\t[\\\"Lato\\\", \\\"'Lato', sans-serif\\\"],\\n\\t[\\\"Montserrat\\\", \\\"'Montserrat', sans-serif\\\"],\\n\\t[\\\"Nova Flat\\\", \\\"'Nova Flat', cursive\\\"],\\n\\t[\\\"Nova Round\\\", \\\"'Nova Round', cursive\\\"],\\n\\t[\\\"Open Sans\\\", \\\"'Open Sans', sans-serif\\\"],\\n\\t[\\\"Playfair Display\\\", \\\"'Playfair Display', serif\\\"],\\n\\t[\\\"Poppins\\\", \\\"'Poppins', sans-serif\\\"],\\n\\t[\\\"Quicksand\\\", \\\"'Quicksand', sans-serif\\\"],\\n\\t[\\\"Roboto Slab\\\", \\\"'Roboto Slab', serif\\\"],\\n\\t[\\\"Roboto Condensed\\\", \\\"'Roboto Condensed', sans-serif\\\"],\\n\\t[\\\"Rubik\\\", \\\"'Rubik', sans-serif\\\"],\\n\\t[\\\"Titillium Web\\\", \\\"'Titillium Web', sans-serif\\\"],\\n\\t[\\\"Ubuntu\\\", \\\"'Ubuntu', sans-serif\\\"]\\n]; \\n \\n\\nfunction receiveMessage(event) {\\n  \\n \\n    const data = event && event.data ? event.data:{}; \\n    if (data && data.action === 'togglePause') {\\n\\t\\tisPaused = data.isPaused; \\n    }\\n  if (data && data.action === 'updatePreview') {clearInterval(intervalHandle); \\n } \\n if (data && data.action === 'changeTemplate') { document.location.href = document.location.href; \\n}  }\\nstartCountup('__message__', '__time__', \\\"__color__\\\",\\\"__fontidx__\\\" ,\\\"__backgroundColor__\\\" ); //init >   msg, duration-in-seconds, foreground-color, background-color\\n\\n\\nfunction tick(){\\n\\n\\tvar timeDisplay = document.getElementById(\\\"time\\\");\\n\\n\\tvar hour = Math.floor(secondCounter / 3600);\\n\\tvar min = Math.floor((secondCounter - (hour * 3600)) / 60);\\n\\tvar sec = secondCounter - (hour * 3600) - (min * 60);\\n\\n\\tif (hour < 10) {\\n\\t\\thour = \\\"0\\\" + hour;\\n\\t}\\n\\n\\tif (sec < 10) {\\n\\t\\tsec = \\\"0\\\" + sec;\\n\\t}\\n\\n\\tif (min < 10) {\\n\\t\\tmin = \\\"0\\\" + min;\\n\\t}\\n\\n\\tvar message = hour.toString() + \\\":\\\" + min.toString() + \\\":\\\" + sec;\\n\\n\\ttimeDisplay.innerHTML = message;\\n\\n\\tif (secondCounter === timelimit){\\n\\t\\tcountupDone();\\n\\t\\tclearInterval(intervalHandle);\\t\\n\\t}\\n\\n\\tsecondCounter++;\\n}\\n\\nfunction startCountup(msg,secs, fgcolor, fontindex=0, bgcolor){ \\n\\t$('body').css(\\\"font-family\\\", tickerfont[fontindex][1]);\\n  \\n\\tvar hms = secs;   // your input string\\n\\tvar a = hms.split(':'); // split it at the colons\\n\\tconst seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);\\n\\n\\tsecondCounter = 0;\\n\\tif (msg != undefined && msg == ''){\\n\\t\\t document.getElementById(\\\"msg\\\").remove()\\n\\t\\t $('h1').css(\\\"padding\\\", '40px');\\n\\n\\t} else{\\n\\t\\t\\n\\t\\tdocument.getElementById(\\\"msg\\\").innerHTML = msg;\\n\\t\\t$('p').css(\\\"font-size\\\", (msg.length) < 14 ? '7vw' : '3vw');\\n\\t\\t$('p').css(\\\"line-height\\\", (msg.length) < 14 ? '1vh' : '6vh');\\n\\t}\\n\\tdocument.getElementById(\\\"countdown\\\").style.color = fgcolor;\\n\\tdocument.getElementById(\\\"container\\\").style.backgroundColor  = bgcolor + __SHOWBG__;\\n\\ttimelimit = secs\\n\\tintervalHandle = setInterval(tick, 1000);\\n\\n}\\n\\nasync function countupDone(){\\n\\tdocument.getElementById(\\\"container\\\").style.display = \\\"none\\\";\\nawait fetch(`${endpoint}/rundownItems/stopAll/${playingId}/${playingStatus}`, {\\n\\t\\t\\t\\tmethod: 'POST',\\n\\t\\t\\t\\theaders: {\\n\\t\\t\\t\\t\\t'Accept': 'application/json',\\n\\t\\t\\t\\t\\t'Content-Type': 'application/json'\\n\\t\\t\\t\\t},\\n\\t\\t\\t})\\n\\t\\t\\t.then((response) => {\\n\\t\\t\\t\\t\\n\\t\\t\\t});\\n }\\n\\n\\n window.addEventListener('message', receiveMessage); \",\"vcam_count\":\"\"}",
	},
	{// count up fixed
		id: 5,
		// eslint-disable-next-line no-template-curly-in-string
		content: "{\"content\":\"<link href=\\\"https://fonts.googleapis.com/css2?family=Abril+Fatface&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Aldrich&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Arvo&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Barlow+Semi+Condensed&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Chakra+Petch&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Dosis:wght@500&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Frank+Ruhl+Libre&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Inria+Serif&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Kaushan+Script&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Lato&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@1,700&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Nova+Flat&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Nova+Round&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Open+Sans&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@1,500&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Poppins&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Quicksand:wght@500&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Roboto+Condensed&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Roboto+Slab&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Rubik&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Titillium+Web&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Ubuntu&display=swap\\\" rel=\\\"stylesheet\\\">\\t\\n<div id=\\\"parentcontainer\\\">\\n  <div id=\\\"container\\\">\\n    <div id=\\\"countdown\\\">\\n      <p  id=\\\"msg\\\">COUNTUP</p>\\n      <h1 id=\\\"time\\\">00:00</h1>\\n    </div>\\n  </div>\\n</div>\",\"style\":\"body { \\n\\tfont-family: 'Montserrat',\\n\\tsans-serif;\\n\\tmargin: 0;\\n  \\tpadding: 0;\\n\\n}\\n\\nh1 { \\n\\tfont-size: 15vw;\\n\\tmargin: 20px;\\n\\tline-height: .5em;\\n\\tletter-spacing: 5px;\\n\\tpadding-bottom: 8vw;\\n}\\n\\np {\\n\\tfont-size: 3vw;\\n\\tpadding-bottom: 0.5vw;\\n}\\n\\n\\n#parentcontainer { \\n  display: flex;\\n  width: 100vw;\\n  height: 100vh;\\n  justify-content: center;\\n  align-items: center;\\n\\n}\\n\\n#container { \\n\\tmargin: 0;\\n\\tdisplay: inline-block;\\n\\tpadding: 15px;\\n\\tborder-radius: 2vw;\\n}\\t\\n\\n#countdown{\\n\\ttext-align: center;\\n}\\n\\n\\nh1 > span {\\n  display: inline-block; /* Enable widths */\\n  width: 1.5em;           /* Set width across all characters */\\n  text-align: center; \\n     /* Even out spacing */\\n}\",\"script\":\"var secondCounter;\\nvar timelimit;\\nvar intervalHandle;\\nvar playingStatus = '__STATUS__'\\nvar playingId = '__PLAYINGID__'\\nvar endpoint = '__APIURL__'\\n\\nvar tickerfont = [\\n\\t[\\\"Abril Fatface\\\", \\\"'Abril Fatface', cursive\\\"],\\n\\t[\\\"Aldrich\\\", \\\"'Aldrich', sans-serif\\\"],\\n\\t[\\\"Arvo\\\", \\\"'Arvo', serif\\\"],\\n\\t[\\\"Barlow Semi Condensed\\\", \\\"'Barlow Semi Condensed', sans-serif\\\"],\\n\\t[\\\"Chakra Petch\\\", \\\"'Chakra Petch', sans-serif\\\"],\\n\\t[\\\"Dosis\\\", \\\"'Dosis', sans-serif\\\"],\\n\\t[\\\"Frank Ruhl Libre\\\", \\\"'Frank Ruhl Libre', serif\\\"],\\n\\t[\\\"IBM Plex Sans\\\", \\\"'IBM Plex Sans', sans-serif\\\"],\\n\\t[\\\"Inria Serif\\\", \\\"'Inria Serif', serif\\\"],\\n\\t[\\\"Kaushan Script\\\", \\\"'Kaushan Script', cursive\\\"],\\n\\t[\\\"Lato\\\", \\\"'Lato', sans-serif\\\"],\\n\\t[\\\"Montserrat\\\", \\\"'Montserrat', sans-serif\\\"],\\n\\t[\\\"Nova Flat\\\", \\\"'Nova Flat', cursive\\\"],\\n\\t[\\\"Nova Round\\\", \\\"'Nova Round', cursive\\\"],\\n\\t[\\\"Open Sans\\\", \\\"'Open Sans', sans-serif\\\"],\\n\\t[\\\"Playfair Display\\\", \\\"'Playfair Display', serif\\\"],\\n\\t[\\\"Poppins\\\", \\\"'Poppins', sans-serif\\\"],\\n\\t[\\\"Quicksand\\\", \\\"'Quicksand', sans-serif\\\"],\\n\\t[\\\"Roboto Slab\\\", \\\"'Roboto Slab', serif\\\"],\\n\\t[\\\"Roboto Condensed\\\", \\\"'Roboto Condensed', sans-serif\\\"],\\n\\t[\\\"Rubik\\\", \\\"'Rubik', sans-serif\\\"],\\n\\t[\\\"Titillium Web\\\", \\\"'Titillium Web', sans-serif\\\"],\\n\\t[\\\"Ubuntu\\\", \\\"'Ubuntu', sans-serif\\\"]\\n]; \\n \\n\\nfunction receiveMessage(event) {\\n  \\n \\n    const data = event && event.data ? event.data:{}; \\n    if (data && data.action === 'togglePause') {\\n\\t\\tisPaused = data.isPaused; \\n    }\\n  if (data && data.action === 'updatePreview') {clearInterval(intervalHandle); \\n } \\n if (data && data.action === 'changeTemplate') { document.location.href = document.location.href; \\n}  }\\nstartCountup('__message__', '__time__', \\\"__color__\\\",\\\"__fontidx__\\\" ,\\\"__backgroundColor__\\\" ); //init >   msg, duration-in-seconds, foreground-color, background-color\\n\\n\\nfunction tick(){\\n\\n\\tvar timeDisplay = document.getElementById(\\\"time\\\");\\n\\n\\tvar hour = Math.floor(secondCounter / 3600);\\n\\tvar min = Math.floor((secondCounter - (hour * 3600)) / 60);\\n\\tvar sec = secondCounter - (hour * 3600) - (min * 60);\\n\\n\\tif (hour < 10) {\\n\\t\\thour = \\\"0\\\" + hour;\\n\\t}\\n\\n\\tif (sec < 10) {\\n\\t\\tsec = \\\"0\\\" + sec;\\n\\t}\\n\\n\\tif (min < 10) {\\n\\t\\tmin = \\\"0\\\" + min;\\n\\t}\\n\\n\\tvar message = hour.toString() + \\\":\\\" + min.toString() + \\\":\\\" + sec;\\n\\n\\ttimeDisplay.innerHTML = message;\\n\\n\\tif (secondCounter === timelimit){\\n\\t\\tcountupDone();\\n\\t\\tclearInterval(intervalHandle);\\t\\n\\t}\\n \\tif (secondCounter === 86399) {\\n      console.log(secondCounter);\\n      secondCounter = 0;\\n    }\\n   secondCounter++;\\n}\\n\\nfunction startCountup(msg,secs, fgcolor, fontindex=0, bgcolor){ \\n\\t$('body').css(\\\"font-family\\\", tickerfont[fontindex][1]);\\n  \\n\\tvar hms = secs;   // your input string\\n\\tvar a = hms.split(':'); // split it at the colons\\n    var date = new Date;\\n    var scnd = date.getSeconds();\\n    var minutes = date.getMinutes();\\n    var hour = date.getHours();\\n\\tconst seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);\\n\\n\\tsecondCounter = seconds;\\n\\tif (msg != undefined && msg == ''){\\n\\t\\t document.getElementById(\\\"msg\\\").remove()\\n\\t\\t $('h1').css(\\\"padding\\\", '40px');\\n\\n\\t} else{\\n\\t\\t\\n\\t\\tdocument.getElementById(\\\"msg\\\").innerHTML = msg;\\n\\t\\t$('p').css(\\\"font-size\\\", (msg.length) < 14 ? '7vw' : '3vw');\\n\\t\\t$('p').css(\\\"line-height\\\", (msg.length) < 14 ? '1vh' : '6vh');\\n\\t}\\n\\tdocument.getElementById(\\\"countdown\\\").style.color = fgcolor;\\n\\tdocument.getElementById(\\\"container\\\").style.backgroundColor  = bgcolor + __SHOWBG__;\\n\\ttimelimit = secs\\n\\tintervalHandle = setInterval(tick, 1000);\\n\\n}\\n\\nasync function countupDone(){\\n\\tdocument.getElementById(\\\"container\\\").style.display = \\\"none\\\";\\nawait fetch(`${endpoint}/rundownItems/stopAll/${playingId}/${playingStatus}`, {\\n\\t\\t\\t\\tmethod: 'POST',\\n\\t\\t\\t\\theaders: {\\n\\t\\t\\t\\t\\t'Accept': 'application/json',\\n\\t\\t\\t\\t\\t'Content-Type': 'application/json'\\n\\t\\t\\t\\t},\\n\\t\\t\\t})\\n\\t\\t\\t.then((response) => {\\n\\t\\t\\t\\t\\n\\t\\t\\t});\\n }\\n\\n\\n window.addEventListener('message', receiveMessage); \",\"vcam_count\":\"\"}",
	},
	{// stopwatch
		id: 6,
		// eslint-disable-next-line no-template-curly-in-string
		content: "{\"content\":\"<link href=\\\"https://fonts.googleapis.com/css2?family=Abril+Fatface&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Aldrich&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Arvo&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Barlow+Semi+Condensed&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Chakra+Petch&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Dosis:wght@500&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Frank+Ruhl+Libre&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Inria+Serif&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Kaushan+Script&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Lato&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@1,700&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Nova+Flat&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Nova+Round&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Open+Sans&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@1,500&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Poppins&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Quicksand:wght@500&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Roboto+Condensed&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Roboto+Slab&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Rubik&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Titillium+Web&display=swap\\\" rel=\\\"stylesheet\\\">\\n\\t<link href=\\\"https://fonts.googleapis.com/css2?family=Ubuntu&display=swap\\\" rel=\\\"stylesheet\\\">\\t\\n<div id=\\\"parentcontainer\\\">\\n  <div id=\\\"container\\\">\\n    <div id=\\\"countdown\\\">\\n      <p  id=\\\"msg\\\">COUNTUP</p>\\n      <h1 id=\\\"time\\\">00:00</h1>\\n    </div>\\n  </div>\\n</div>\",\"style\":\"body { \\n\\tfont-family: 'Montserrat',\\n\\tsans-serif;\\n\\tmargin: 0;\\n  \\tpadding: 0;\\n\\n}\\n\\nh1 { \\n\\tfont-size: 15vw;\\n\\tmargin: 20px;\\n\\tline-height: .5em;\\n\\tletter-spacing: 5px;\\n\\tpadding-bottom: 8vw;\\n}\\n\\np {\\n\\tfont-size: 3vw;\\n\\tpadding-bottom: 0.5vw;\\n}\\n\\n\\n#parentcontainer { \\n  display: flex;\\n  width: 100vw;\\n  height: 100vh;\\n  justify-content: center;\\n  align-items: center;\\n\\n}\\n\\n#container { \\n\\tmargin: 0;\\n\\tdisplay: inline-block;\\n\\tpadding: 15px;\\n\\tborder-radius: 2vw;\\n}\\t\\n\\n#countdown{\\n\\ttext-align: center;\\n}\\n\\n\\nh1 > span {\\n  display: inline-block; /* Enable widths */\\n  width: 1.5em;           /* Set width across all characters */\\n  text-align: center; \\n     /* Even out spacing */\\n}\",\"script\":\"var secondCounter;\\nvar timelimit;\\nvar intervalHandle;\\nvar playingStatus = '__STATUS__'\\nvar playingId = '__PLAYINGID__'\\nvar endpoint = '__APIURL__'\\nvar isPaused = __ISPAUSED__;\\n\\nvar tickerfont = [\\n\\t[\\\"Abril Fatface\\\", \\\"'Abril Fatface', cursive\\\"],\\n\\t[\\\"Aldrich\\\", \\\"'Aldrich', sans-serif\\\"],\\n\\t[\\\"Arvo\\\", \\\"'Arvo', serif\\\"],\\n\\t[\\\"Barlow Semi Condensed\\\", \\\"'Barlow Semi Condensed', sans-serif\\\"],\\n\\t[\\\"Chakra Petch\\\", \\\"'Chakra Petch', sans-serif\\\"],\\n\\t[\\\"Dosis\\\", \\\"'Dosis', sans-serif\\\"],\\n\\t[\\\"Frank Ruhl Libre\\\", \\\"'Frank Ruhl Libre', serif\\\"],\\n\\t[\\\"IBM Plex Sans\\\", \\\"'IBM Plex Sans', sans-serif\\\"],\\n\\t[\\\"Inria Serif\\\", \\\"'Inria Serif', serif\\\"],\\n\\t[\\\"Kaushan Script\\\", \\\"'Kaushan Script', cursive\\\"],\\n\\t[\\\"Lato\\\", \\\"'Lato', sans-serif\\\"],\\n\\t[\\\"Montserrat\\\", \\\"'Montserrat', sans-serif\\\"],\\n\\t[\\\"Nova Flat\\\", \\\"'Nova Flat', cursive\\\"],\\n\\t[\\\"Nova Round\\\", \\\"'Nova Round', cursive\\\"],\\n\\t[\\\"Open Sans\\\", \\\"'Open Sans', sans-serif\\\"],\\n\\t[\\\"Playfair Display\\\", \\\"'Playfair Display', serif\\\"],\\n\\t[\\\"Poppins\\\", \\\"'Poppins', sans-serif\\\"],\\n\\t[\\\"Quicksand\\\", \\\"'Quicksand', sans-serif\\\"],\\n\\t[\\\"Roboto Slab\\\", \\\"'Roboto Slab', serif\\\"],\\n\\t[\\\"Roboto Condensed\\\", \\\"'Roboto Condensed', sans-serif\\\"],\\n\\t[\\\"Rubik\\\", \\\"'Rubik', sans-serif\\\"],\\n\\t[\\\"Titillium Web\\\", \\\"'Titillium Web', sans-serif\\\"],\\n\\t[\\\"Ubuntu\\\", \\\"'Ubuntu', sans-serif\\\"]\\n];\\nstartCountup('__message__', '__time__', \\\"__color__\\\",\\\"__fontidx__\\\" ,\\\"__backgroundColor__\\\" ); //init >   msg, duration-in-seconds, foreground-color, background-color\\n\\nfunction receiveMessage(event) {\\n  \\n \\n    const data = event && event.data ? event.data:{}; \\n    if (data && data.action === 'togglePause') {\\n\\t\\tisPaused = data.isPaused; \\n    }\\n  if (data && data.action === 'updatePreview') {  clearInterval(intervalHandle); \\n} \\n if (data && data.action === 'changeTemplate') { document.location.href = document.location.href; \\n} }\\n\\nfunction tick(){\\n\\n\\tvar timeDisplay = document.getElementById(\\\"time\\\");\\n\\n\\tvar hour = Math.floor(secondCounter / 3600);\\n\\tvar min = Math.floor((secondCounter - (hour * 3600)) / 60);\\n\\tvar sec = secondCounter - (hour * 3600) - (min * 60);\\n\\n\\tif (hour < 10) {\\n\\t\\thour = \\\"0\\\" + hour;\\n\\t}\\n\\n\\tif (sec < 10) {\\n\\t\\tsec = \\\"0\\\" + sec;\\n\\t}\\n\\n\\tif (min < 10) {\\n\\t\\tmin = \\\"0\\\" + min;\\n\\t}\\n\\n\\tvar message = hour.toString() + \\\":\\\" + min.toString() + \\\":\\\" + sec;\\n\\n\\ttimeDisplay.innerHTML = message;\\n\\t\\n\\tif (secondCounter > timelimit){\\n\\t\\tcountupDone();\\n\\t\\tclearInterval(intervalHandle);\\t\\n\\t}\\n  \\n\\n  \\t\\n\\tif (!isPaused) {\\n\\t\\tsecondCounter++;\\n  \\t}\\n}\\n\\nfunction startCountup(msg,secs, fgcolor, fontindex=0, bgcolor){ \\n\\t$('body').css(\\\"font-family\\\", tickerfont[fontindex][1]);\\n  \\n\\tvar hms = secs;   // your input string\\n\\tvar a = hms.split(':'); // split it at the colons\\n\\tconst seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);\\n\\n\\tsecondCounter = 0;\\n\\tif (msg != undefined && msg == ''){\\n\\t\\t document.getElementById(\\\"msg\\\").remove()\\n\\t\\t $('h1').css(\\\"padding\\\", '40px');\\n\\t} else{\\n\\t\\tdocument.getElementById(\\\"msg\\\").innerHTML = msg;\\n\\t\\t$('p').css(\\\"font-size\\\", (msg.length) < 14 ? '7vw' : '3vw');\\n\\t\\t$('p').css(\\\"line-height\\\", (msg.length) < 14 ? '1vh' : '6vh');\\n\\t}\\n\\tdocument.getElementById(\\\"countdown\\\").style.color = fgcolor;\\n\\tdocument.getElementById(\\\"container\\\").style.backgroundColor  = bgcolor + __SHOWBG__;\\n\\ttimelimit = seconds\\n\\tintervalHandle = setInterval(tick, 1000);\\n\\n}\\n\\nasync function countupDone(){\\n\\tdocument.getElementById(\\\"container\\\").style.display = \\\"none\\\";\\nawait fetch(`${endpoint}/rundownItems/stopAll/${playingId}/${playingStatus}`, {\\n\\t\\t\\t\\tmethod: 'POST',\\n\\t\\t\\t\\theaders: {\\n\\t\\t\\t\\t\\t'Accept': 'application/json',\\n\\t\\t\\t\\t\\t'Content-Type': 'application/json'\\n\\t\\t\\t\\t},\\n\\t\\t\\t})\\n\\t\\t\\t.then((response) => {\\n\\t\\t\\t\\t\\n\\t\\t\\t});\\n}\\n\\n\\n window.addEventListener('message', receiveMessage);\",\"vcam_count\":\"\"}",
	},
];

export const tourData = [
	// quick start INDEX 1
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Quickstart/TourMenu.png',
			title: 'You are smart!',
			description: 'Get value from grafias today<br>This guide will show you the features<br>Turn it ON in profile settings',
			index: 1,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Quickstart/01.gif',
			title: 'Cloud-based production',
			description: 'Click the Quick Start Rundown button, this will import a sample rundown for you to explore<br><br>Learn about cloud-based graphics, click Next',
			index: 1,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Quickstart/rundown.png',
			title: 'Rundown',
			description: 'Create graphics, timers, tickers, or add video and audio. Share it with your team and clients',
			index: 1,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Quickstart/02.gif',
			title: 'Plan your live production',
			description: 'Save time in preproduction<br>Edit the graphics in the Property Editor in real-time, together with your team and client',
			index: 1,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Quickstart/03.gif',
			title: 'Show the rundown to clients',
			description: 'Add the assets you need for the event. Click on the title to PREVIEW or PLAY to go LIVE<br>Collaborate with client so you have all the assets you need',
			index: 1,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Quickstart/04.gif',
			title: 'Work from anywhere',
			description: 'Add stunning graphics right in your browser, no expensive hardware required. Operate from any location',
			index: 1,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Quickstart/05.gif',
			title: 'One click to go live',
			description: 'Save time from pre-production to live production<br>LIVE window is what the your audience see<br>Make fast changes on the fly, and use Preview to check that all is ok',
			index: 1,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Quickstart/06.gif',
			title: 'Publish to your audience',
			description: 'Click View output, click Publish on Default display and click save. Create as many outputs you need and control it from same rundown.',
			index: 1,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Quickstart/07.gif',
			title: 'Vision mixer or cloud-based',
			description: 'Whether it’s vision mixers or cloud-based, integrate your rundown with any production tool with support for web source. Output to NDI, SDI with fill & Key',
			index: 1,
		},
	],
	// Rundowns INDEX 2
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Rundowns/Rundown+-+1+%E2%80%93+1.png',
			title: 'Add Asset',
			description: 'Click the plus button or Click to Add asset, select the asset you want to add and click',
			index: 2,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Rundowns/Rundown+-+1+%E2%80%93+2.png',
			title: 'Edit Property',
			description: 'Change the asset property, Name, Heading text, Duration, Image attachment, color and position<br>Every asset has different set of property',
			index: 2,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Rundowns/Rundown+-+1+%E2%80%93+3.png',
			title: 'Layer Index',
			description: 'Each asset occupied a layer index, only one asset can be active at a time, separate your asset in several layer index if you want to show it all at once',
			index: 2,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Rundowns/Rundown+-+1+-+4.gif',
			title: 'Select Template',
			description: 'For Lower third asset, you can select the various template from our library, open the gallery window, select the tempate for preview, double click or click Use this Template button to select the template for the asset',
			index: 2,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Rundowns/Rundown+-+1+%E2%80%93+5.png',
			title: 'PREVIEW',
			description: 'Quick view when editing the property of your asset, or transform the asset by draggin the bounding box<br>click on the asset name on the rundown, a green marker will appear on the left side of the asset',
			index: 2,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Rundowns/Rundown+-+1+%E2%80%93+6.png',
			title: 'PLAY',
			description: 'PLAY window is similar to PROGRAM window, its the final output view for your rundown',
			index: 2,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Rundowns/Rundown+-+1+%E2%80%93+7.png',
			title: 'Arrange Asset',
			description: 'Drag and Drop your asset on the rundown to change its order, add marker asset to make separate section so its easier to mage during live production',
			index: 2,
		},
	],
	// Rundown Settings INDEX 3
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/RundownSettings/Rundown+Setting+%E2%80%93+1.png',
			title: 'Filter & Search',
			description: 'Quickly find your asset by filtering the asset type or search by name',
			index: 3,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/RundownSettings/Rundown+Setting+%E2%80%93+2.png',
			title: 'STOP',
			description: 'Stop all graphics in LIVE and PREVIEW at once, right click on the stop button to select either PREVIEW or LIVE only',
			index: 3,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/RundownSettings/Rundown+Setting+%E2%80%93+3.png',
			title: 'Clear Output',
			description: 'Similar to STOP this will force clear all the graphics on the output display',
			index: 3,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/RundownSettings/Rundown+Setting+%E2%80%93+4.png',
			title: 'Rename Rundown',
			description: 'My Event Rundown is the default name for newly created rundown, choose this menu to rename your rundown or double click on the rundown title on top left',
			index: 3,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/RundownSettings/Rundown+Setting+%E2%80%93+5.png',
			title: 'Clear Rundown',
			description: 'This action will reset or delete all asset on your rundown',
			index: 3,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/RundownSettings/Rundown+Setting+%E2%80%93+6.png',
			title: 'Render Rundown',
			description: 'You can export all the lower third as PNG sequence or MP4, for your NLE editor or other usage<br>A link to download the files will be send via email',
			index: 3,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/RundownSettings/Rundown+Setting+%E2%80%93+7.png',
			title: 'Export Import',
			description: 'Export or Import rundown in Microsoft Excel format, if you have a lot of asset data, editing the excel file will save you alot of time. Grafias can handle hundreds of lower third data, for example list of graduated students',
			index: 3,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/RundownSettings/Rundown+Setting+%E2%80%93+8.png',
			title: 'Import Lower Third Data',
			description: 'You can also import a specified excel format, fill in the data, and import to Grafias, select the template for this data and it will generate all the assets',
			index: 3,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/RundownSettings/Rundown+Setting+%E2%80%93+9.png',
			title: 'Rebuild Cache',
			description: 'To ensure smooth playback, Grafias cache all media file, rebuild cache will download and cache the latest file for your rundown',
			index: 3,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/RundownSettings/Rundown+Setting+%E2%80%93+10.png',
			title: 'Canvas Background',
			description: 'Change the background of LIVE and PREVIEW pane, by default is black luma, this setting is different from the output display type',
			index: 3,
		},
	],
	// Output In-Depth INDEX 4
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Output/Output+In-Depth+%E2%80%93+1.png',
			title: 'Output List',
			description: 'View the output list, you can assign multiple output to a rundown, an output ony can be assign to a single rundown<br>Create output or view the multiview, multiview button only visible if you have more than one output',
			index: 4,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Output/Output+In-Depth+%E2%80%93+2.png',
			title: 'Create Output',
			description: 'Add output, Set the name and size based on the preset',
			index: 4,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Output/Output+In-Depth+%E2%80%93+3.png',
			title: 'Output Layers',
			description: 'Select output layers from the rundown, type in index layer then press enter, you can include several index in the output, or set 0 to display all index',
			index: 4,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Output/Output+In-Depth+%E2%80%93+4.png',
			title: 'Output Delay',
			description: 'Output delay in milliseconds, adjust the delay so it can be sync perfectly to your other output or stream',
			index: 4,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Output/Output+In-Depth+%E2%80%93+5.png',
			title: 'Background',
			description: 'Select the output background, Straight alpha, Luma (black) or Chroma (green), for OBS, select straight alpha, for other mixer select Luma or Chroma',
			index: 4,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Output/Output+In-Depth+%E2%80%93+6.gif',
			title: 'Assign Output',
			description: 'On Active Rundown, click select output, then click Publish button to assign an ouput to your rundown, then click Save',
			index: 4,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Output/Output+In-Depth+%E2%80%93+7.png',
			title: 'Active Output',
			description: 'View all active output assigned for this rundown, Click to open it on a new browser tab',
			index: 4,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Output/Output+In-Depth+%E2%80%93+8.png',
			title: 'Multiview',
			description: 'View all output in one place',
			index: 4,
		},
	],
	// Collaboration INDEX 5
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Collaborator/1.png',
			title: 'Collaborator List',
			description: 'Overview of all the collaborator, their role and the rundown',
			index: 5,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Collaborator/2.png',
			title: 'Invite Add Collaborator',
			description: 'Fill in the fullname and email field',
			index: 5,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Collaborator/3.png',
			title: 'Select Role',
			description: 'For Creator it is allowed to add and edit the rundown, but its not allowed to set the output or control during live session<br>Operator is for technical operator at the event, that set the output and control the rundown playback',
			index: 5,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Collaborator/4.png',
			title: 'Rundowns',
			description: 'Select the rundown to collaborate with, you can work on multiple rundown withe one user, the rundown will appear on user dashboard',
			index: 5,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Collaborator/5.png',
			title: 'Create Collaborator',
			description: 'An email will be dispatched to user, with quick registration process, non grafias user will easily start to collaborate on selected rundown',
			index: 5,
		},
	],
	// Asset - Lower Third INDEX 6
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+1.png',
			title: 'Overview Lower Third',
			description: 'Ready to use and fully customized lower third graphics to improve your production',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+2.gif',
			title: 'Select Template - Template Library',
			description: 'Many selection graphics library and will continue to grow<br>Search, filter or create your own graphic using Adobe After Effects and Bodymovin plugin (Lottie)',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+3.png',
			title: 'Heading',
			description: 'Basic template has maximum four heading (H1-H4), each template has different heading, fill in to replace the default text',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+4.png',
			title: 'Duration',
			description: 'Set the duration for the lower third, this is a peak point from transition in before it goes to transition out',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+5.png',
			title: 'Colors',
			description: 'Each template has different number of heading and element, change the color and opacity from the color picker',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+6.png',
			title: 'Text Drop Shadow',
			description: 'Enable drop shadow on the heading element',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+7.png',
			title: 'Gradient Color',
			description: ' Element on the template will have a gradient style, Solid color is the default looks',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+8.png',
			title: 'Label',
			description: 'The name of the asset, proper naming practice recommended',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+9.png',
			title: 'Layer',
			description: 'Asset layer Index, the occupied index icon will shown if the asset has the same index with other asset in the rundown',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+10.png',
			title: 'Speed',
			description: 'Change the playback speed, higher number is the fastest playback speed',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/LowerThird/Asset+-+Lower-third+%E2%80%93+11.png',
			title: 'Scale',
			description: 'Scale the graphics with predefined size (within)',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Size+Position.png',
			title: 'Size And Position',
			description: 'Transform the size and position of the asset, locked ratio to ensure proportional scaling, reset button to revert changes on the asset',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/On+Complete.png',
			title: 'On Complete',
			description: 'Trigger another asset to play, when current asset finished playing, select another asset from the dropdown',
			index: 6,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Parent+Controller.png',
			title: 'Parent Controller',
			description: 'Linked one or many asset with one trigger, if you need to show several asset at once, instead of click play button one by one, just link asset to another asset - Learn more on parent controller',
			index: 6,
		},
	],
	// Asset - Media INDEX 7
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Media/Asset+-+Media+%E2%80%93+1.png',
			title: 'Overview Media',
			description: 'Play still image or video file from your rundown',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Media/Asset+-+Media+%E2%80%93+2.gif',
			title: 'Media File',
			description: 'Upload from your device or select media from our library<br>For video files, MP4 files with HD resolution and medium bitrate for web playback are recommended',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Media/Asset+-+Media+%E2%80%93+3.png',
			title: 'Video Loop & Mute Audio',
			description: 'Loop the video playback and mute if the video has embedded audio',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Media/Asset+-+Media+%E2%80%93+4.png',
			title: 'Label',
			description: 'The name of the asset, proper naming practice recommended',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Media/Asset+-+Media+%E2%80%93+5.png',
			title: 'In and Out Point',
			description: 'Define media playback length, split the playback from one file into several asset , without the need to edit or cut the media into separate file',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Media/Asset+-+Media+%E2%80%93+6.png',
			title: 'Opacity',
			description: 'Set the asset opacity',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Media/Asset+-+Media+%E2%80%93+7.png',
			title: 'Layer',
			description: 'Asset layer Index, the occupied index icon will shown if the asset has the same index with other asset in the rundown',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Media/Asset+-+Media+%E2%80%93+8.png',
			title: 'Border',
			description: 'Border on the edge of the media file, change the thickness and color, if you crop the media the border will follow the cropped area',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Media/Asset+-+Media+%E2%80%93+9.png',
			title: 'Crop Media',
			description: 'Crop the media, adjust the cropped amount on each side in pixels',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Size+Position.png',
			title: 'Size And Position',
			description: 'Transform the size and position of the asset, locked ratio to ensure proportional scaling, reset button to revert changes on the asset',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/On+Complete.png',
			title: 'On Complete',
			description: 'Trigger another asset to play, when current asset finished playing, select another asset from the dropdown',
			index: 7,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Parent+Controller.png',
			title: 'Parent Controller',
			description: 'Linked one or many asset with one trigger, if you need to show several asset at once, instead of click play button one by one, just link asset to another asset - Learn more on parent controller',
			index: 7,
		},
	],
	// Asset - Lottie INDEX 8
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Lottie/Asset+-+Lottie+%E2%80%93+1.png',
			title: 'Overview Lottie',
			description: 'Play lottie animations<br>Upload your lottie (json) file, or select from pur library, if your lottie files as bitmap assets, zip it and upload it as well',
			index: 8,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Lottie/Asset+-+Lottie+%E2%80%93+2.png',
			title: 'Label',
			description: 'The name of the asset, proper naming practice recommended',
			index: 8,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Lottie/Asset+-+Lottie+%E2%80%93+3.png',
			title: 'Loop',
			description: 'Loop the video playback and mute if the video has embedded audio',
			index: 8,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Lottie/Asset+-+Lottie+%E2%80%93+4.png',
			title: 'Layer',
			description: 'Asset layer Index, the occupied index icon will shown if the asset has the same index with other asset in the rundown',
			index: 8,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Size+Position.png',
			title: 'Size And Position',
			description: 'Transform the size and position of the asset, locked ratio to ensure proportional scaling, reset button to revert changes on the asset',
			index: 8,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/On+Complete.png',
			title: 'On Complete',
			description: 'Trigger another asset to play, when current asset finished playing, select another asset from the dropdown',
			index: 8,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Parent+Controller.png',
			title: 'Parent Controller',
			description: 'Linked one or many asset with one trigger, if you need to show several asset at once, instead of click play button one by one, just link asset to another asset - Learn more on parent controller',
			index: 8,
		},
	],
	// Asset - Ticker INDEX 9
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Ticker/Asset+-+Ticker++%E2%80%93+1.png',
			title: 'Overview Ticker',
			description: 'Scrolling text across your display',
			index: 9,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Ticker/Asset+-+Ticker++%E2%80%93+2.png',
			title: 'Title & Display Time',
			description: 'Ticker title will appear on the left side, will have darker background, it can also display current time if you enable display time option',
			index: 9,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Ticker/Asset+-+Ticker++%E2%80%93+3.png',
			title: 'Ticker Data',
			description: 'Type in your ticker text then press enter to create your text, click the cross icon to remove it from the data',
			index: 9,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Ticker/Asset+-+Ticker++%E2%80%93+4.png',
			title: 'Ticker Style',
			description: 'Change the font style, color and the background of your ticker',
			index: 9,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Ticker/Asset+-+Ticker++%E2%80%93+5.png',
			title: 'Gradient & Hard Gradient',
			description: 'Enable and change the gradient style',
			index: 9,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Ticker/Asset+-+Ticker++%E2%80%93+6.png',
			title: 'Label',
			description: 'The name of the asset, proper naming practice recommended',
			index: 9,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Ticker/Asset+-+Ticker++%E2%80%93+7.png',
			title: 'Layer',
			description: 'Asset layer Index, the occupied index icon will shown if the asset has the same index with other asset in the rundown',
			index: 9,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Size+Position.png',
			title: 'Size And Position',
			description: 'Transform the size and position of the asset, locked ratio to ensure proportional scaling, reset button to revert changes on the asset',
			index: 9,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Parent+Controller.png',
			title: 'Parent Controller',
			description: 'Linked one or many asset with one trigger, if you need to show several asset at once, instead of click play button one by one, just link asset to another asset - Learn more on parent controller',
			index: 9,
		},
	],
	// Asset - Timer INDEX 10
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Timer/Asset+-+Timer++%E2%80%93+1.png',
			title: 'Overview Timer',
			description: 'Create a time based counter display, there are several type of timer to fit your production',
			index: 10,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Timer/Asset+-+Timer++%E2%80%93+2.png',
			title: 'Message',
			description: 'Display a message for the timer, clear the input to remove the message',
			index: 10,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Timer/Asset+-+Timer++%E2%80%93+3.png',
			title: 'Duration or Time',
			description: 'Target duration or time, depends on the timer type, both have specific needs, select between a fixed time or a duration length',
			index: 10,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Timer/Asset+-+Timer++%E2%80%93+4.png',
			title: 'Timer Style',
			description: 'Change the font style, color and the background of your ticker',
			index: 10,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Timer/Asset+-+Timer++%E2%80%93+5.png',
			title: 'Label',
			description: 'The name of the asset, proper naming practice recommended',
			index: 10,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Timer/Asset+-+Timer++%E2%80%93+6.png',
			title: 'Layer',
			description: 'Asset layer Index, the occupied index icon will shown if the asset has the same index with other asset in the rundown',
			index: 10,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Size+Position.png',
			title: 'Size And Position',
			description: 'Transform the size and position of the asset, locked ratio to ensure proportional scaling, reset button to revert changes on the asset',
			index: 10,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/On+Complete.png',
			title: 'On Complete',
			description: 'Trigger another asset to play, when current asset finished playing, select another asset from the dropdown',
			index: 10,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Parent+Controller.png',
			title: 'Parent Controller',
			description: 'Linked one or many asset with one trigger, if you need to show several asset at once, instead of click play button one by one, just link asset to another asset - Learn more on parent controller',
			index: 10,
		},
	],
	// Asset - Audio INDEX 11
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Audio/Asset+-+Audio++%E2%80%93+1.png',
			title: 'Overview Audio',
			description: 'Playback audio with lyrics on your production - supported type .wav, .mp3, .ogg',
			index: 11,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Audio/Asset+-+Audio++%E2%80%93+2.png',
			title: 'Upload Audio or Select From Gallery',
			description: 'Select audio file from your computer or select from our library',
			index: 11,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Audio/Asset+-+Audio++%E2%80%93+3.png',
			title: 'Upload Lyric',
			description: 'in XML or JSON format, see example on how to set the lyrics timing',
			index: 11,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Audio/Asset+-+Audio++%E2%80%93+4.png',
			title: 'In and Out Point',
			description: 'Define media playback length, split the playback from one file into several asset , without the need to edit or cut the media into separate file',
			index: 11,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Audio/Asset+-+Audio++%E2%80%93+5.png',
			title: 'Loop and Mute',
			description: 'Loop audio playback<br>Quickly turn the audio on and off with toggle',
			index: 11,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Audio/Asset+-+Audio++%E2%80%93+6.png',
			title: 'Lyric Style',
			description: 'Change the font style, color and the background of your lyrics',
			index: 11,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Audio/Asset+-+Audio++%E2%80%93+7.png',
			title: 'Label',
			description: 'The name of the asset, proper naming practice recommended',
			index: 11,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Audio/Asset+-+Audio++%E2%80%93+8.png',
			title: 'Layer',
			description: 'Asset layer Index, the occupied index icon will shown if the asset has the same index with other asset in the rundown',
			index: 11,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Size+Position.png',
			title: 'Size And Position',
			description: 'Transform the size and position of the asset, locked ratio to ensure proportional scaling, reset button to revert changes on the asset',
			index: 11,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/On+Complete.png',
			title: 'On Complete',
			description: 'Trigger another asset to play, when current asset finished playing, select another asset from the dropdown',
			index: 11,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Parent+Controller.png',
			title: 'Parent Controller',
			description: 'Linked one or many asset with one trigger, if you need to show several asset at once, instead of click play button one by one, just link asset to another asset - Learn more on parent controller',
			index: 11,
		},
	],
	// Asset - Marker INDEX 12
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Marker/Asset+-+Marker++%E2%80%93+1.png',
			title: 'Overview Marker',
			description: 'Organize your rundown with marker, separate rundown with marker',
			index: 12,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Marker/Asset+-+Marker++%E2%80%93+2.png',
			title: 'Label',
			description: 'The name of the asset, proper naming practice recommended',
			index: 12,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/Marker/Asset+-+Marker++%E2%80%93+3.png',
			title: 'Color Style',
			description: 'Change the font color and background for your marker',
			index: 12,
		},
	],
	// Asset - Video Input INDEX 13
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/VideoInput/Asset+-+VideoInput++%E2%80%93+1.png',
			title: 'Overview Video Input',
			description: 'Select the video device from the list, webcam, digital camera, NDI or other camera source will be listed here<br>Allow access to camera if the permission popup appear.',
			index: 13,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/VideoInput/Asset+-+VideoInput++%E2%80%93+2.png',
			title: 'Label',
			description: 'The name of the asset, proper naming practice recommended',
			index: 13,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/VideoInput/Asset+-+VideoInput++%E2%80%93+3.png',
			title: 'Audio Input',
			description: 'Select the audio input from the device list',
			index: 13,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/VideoInput/Asset+-+VideoInput++%E2%80%93+4.png',
			title: 'Mute Audio',
			description: 'Mute the audio from the input device',
			index: 13,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/VideoInput/Asset+-+VideoInput++%E2%80%93+5.png',
			title: 'Layer',
			description: 'Asset layer Index, the occupied index icon will shown if the asset has the same index with other asset in the rundown',
			index: 13,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/VideoInput/Asset+-+VideoInput++%E2%80%93+6.png',
			title: 'Border',
			description: 'Border on the edge of the media file, change the thickness and color, if you crop the media the border will follow the cropped area',
			index: 13,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/VideoInput/Asset+-+VideoInput++%E2%80%93+7.png',
			title: 'Crop Media',
			description: 'Crop the media, adjust the cropped amount on each side in pixels',
			index: 13,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Size+Position.png',
			title: 'Size And Position',
			description: 'Transform the size and position of the asset, locked ratio to ensure proportional scaling, reset button to revert changes on the asset',
			index: 13,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Parent+Controller.png',
			title: 'Parent Controller',
			description: 'Linked one or many asset with one trigger, if you need to show several asset at once, instead of click play button one by one, just link asset to another asset - Learn more on parent controller',
			index: 13,
		},
	],
	// Asset - Browser Source INDEX 14
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/BrowserSource/Asset+-+BrowserSourrce++%E2%80%93+1.png',
			title: 'Overview Browser Source',
			description: 'Embed Youtube video or webpage for your production',
			index: 14,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/BrowserSource/Asset+-+BrowserSourrce++%E2%80%93+2.png',
			title: 'URL',
			description: 'Fill in the url for the webpage',
			index: 14,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/BrowserSource/Asset+-+BrowserSourrce++%E2%80%93+3.png',
			title: 'Label and Show Label',
			description: 'The name of the asset, proper naming practice recommended, enable this to show the label on the asset',
			index: 14,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/BrowserSource/Asset+-+BrowserSourrce++%E2%80%93+4.png',
			title: 'Layer',
			description: 'Asset layer Index, the occupied index icon will shown if the asset has the same index with other asset in the rundown',
			index: 14,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/BrowserSource/Asset+-+BrowserSourrce++%E2%80%93+5.png',
			title: 'Border',
			description: 'Border on the edge of the media file, change the thickness and color, if you crop the media the border will follow the cropped area',
			index: 14,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/BrowserSource/Asset+-+BrowserSourrce++%E2%80%93+6.png',
			title: 'Crop Media',
			description: 'Crop the media, adjust the cropped amount on each side in pixels',
			index: 14,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Size+Position.png',
			title: 'Size And Position',
			description: 'Transform the size and position of the asset, locked ratio to ensure proportional scaling, reset button to revert changes on the asset',
			index: 14,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/SizePositionComplete/Parent+Controller.png',
			title: 'Parent Controller',
			description: 'Linked one or many asset with one trigger, if you need to show several asset at once, instead of click play button one by one, just link asset to another asset - Learn more on parent controller',
			index: 14,
		},
	],
	// Asset - Custom Command INDEX 15
	[
		{
			preview: '/img/content-placeholder.gif',
			title: 'Overview Custom Command',
			description: 'Embed Youtube video or webpage for your production',
			index: 15,
		},
	],
	// Asset - Composition INDEX 16
	[
		{
			preview: '/img/content-placeholder.gif',
			title: 'Overview Composition',
			description: 'Embed Youtube video or webpage for your production',
			index: 16,
		},
	],
	// Asset - Parent INDEX 17
	[
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/ParentController/Parent+Controller+Detail+-+1.png',
			title: 'Parent Controller Toggle',
			description: 'Enable current as parent controller, all child linked to current asset will follow its state<br>if disabled, linked asset (child) will be ignored',
			index: 17,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/ParentController/Parent+Controller+Detail+-+2.png',
			title: 'Select Parent Item',
			description: 'Select Parent Item',
			index: 17,
		},
		{
			preview: 'https://grafias-medias.s3.eu-central-1.amazonaws.com/Tour/ParentController/Parent+Controller+Detail+-+3.png',
			title: 'Delay',
			description: 'the child asset can be shown before or after the parent is triggered, the delay is in milliseconds',
			index: 17,
		},
	],
];

export const relatedTopics = [
	// INDEX 1
	{
		topic: ['Rundown', 'Rundown Settings', 'Output in-Depth', 'Collaboration'],
	},
	// INDEX 2
	{
		topic: ['Rundown Settings', 'Output in-Depth', 'Asset Lower Third'],
	},
	// INDEX 3
	{
		topic: ['Rundown', 'Output in-Depth', 'Collaboration'],
	},
	// INDEX 4
	{
		topic: ['Rundown', 'Rundown Settings', 'Collaboration', 'Quickstart'],
	},
	// INDEX 5
	{
		topic: ['Rundown', 'Rundown Settings', 'Output in-Depth', 'Quickstart'],
	},
	// INDEX 6
	{
		topic: ['Rundown', 'Media', 'Lottie', 'Ticker', 'Timer', 'Audio', 'Marker', 'Video Input', 'Browser Source'],
	},
	// INDEX 7
	{
		topic: ['Rundown', 'Lower Third', 'Lottie', 'Ticker', 'Timer', 'Audio', 'Marker', 'Video Input', 'Browser Source'],
	},
	// INDEX 8
	{
		topic: ['Rundown', 'Lower Third', 'Media', 'Ticker', 'Timer', 'Audio', 'Marker', 'Video Input', 'Browser Source'],
	},
	// INDEX 9
	{
		topic: ['Rundown', 'Lower Third', 'Media', 'Lottie', 'Timer', 'Audio', 'Marker', 'Video Input', 'Browser Source'],
	},
	// INDEX 10
	{
		topic: ['Rundown', 'Lower Third', 'Media', 'Lottie', 'Ticker', 'Audio', 'Marker', 'Video Input', 'Browser Source'],
	},
	// INDEX 11
	{
		topic: ['Rundown', 'Lower Third', 'Media', 'Lottie', 'Ticker', 'Timer', 'Marker', 'Video Input', 'Browser Source'],
	},
	// INDEX 12
	{
		topic: ['Rundown', 'Lower Third', 'Media', 'Lottie', 'Ticker', 'Timer', 'Audio', 'Video Input', 'Browser Source'],
	},
	// INDEX 13
	{
		topic: ['Rundown', 'Lower Third', 'Media', 'Lottie', 'Ticker', 'Timer', 'Audio', 'Marker', 'Browser Source'],
	},
	// INDEX 14
	{
		topic: ['Rundown', 'Lower Third', 'Media', 'Lottie', 'Ticker', 'Timer', 'Audio', 'Marker', 'Video Input'],
	},
	// INDEX 15
	{
		topic: ['Rundown', 'Lower Third', 'Media', 'Lottie', 'Ticker', 'Timer', 'Audio', 'Marker', 'Video Input', 'Browser Source'],
	},
	// INDEX 16
	{
		topic: ['Rundown', 'Lower Third', 'Media', 'Lottie', 'Ticker', 'Timer', 'Audio', 'Marker', 'Video Input', 'Browser Source'],
	},
	// INDEX 17
	{
		topic: ['Rundown', 'Lower Third', 'Media', 'Lottie', 'Ticker', 'Timer', 'Audio', 'Marker', 'Video Input', 'Browser Source'],
	},
];
